import { render, staticRenderFns } from "./Geolocation.vue?vue&type=template&id=befcd480&scoped=true&"
import script from "./Geolocation.vue?vue&type=script&lang=js&"
export * from "./Geolocation.vue?vue&type=script&lang=js&"
import style0 from "./Geolocation.vue?vue&type=style&index=0&id=befcd480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befcd480",
  null
  
)

export default component.exports